import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import App from "./App";
import "./index.css";
import store from "./app/store/store";
import {
  loadStateFromLocalStorage,
  loginSuccess,
} from "./app/store/auth/authSlice";
import { getAllFoodItems } from "./app/firebase/firebaseFunctions";
import { setFoodItems } from "./app/store/productSlice";

const container = document.getElementById("root");
const root = createRoot(container);

const isAuthenticated = store.getState().auth.isAuthenticated;

if (isAuthenticated) {
  const serializedUser = loadStateFromLocalStorage().user;
  store.dispatch(loginSuccess(serializedUser));
}

const fetchData = async () => {
  await getAllFoodItems().then((data) => {
    store.dispatch(setFoodItems(data));
    console.log(data);
  });
};
fetchData();

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
